import { frontendURL } from '../../../helper/URLHelper';
const AiAgentsShell = () => import('./AiAgentsShell.vue');
const AiAgentsIndex = () => import('./Index.vue');
const AiAgentCreate = () => import('./Create.vue');
const AiAgentTemplates = () => import('./Templates.vue');
const AiAgentTemplatePreview = () => import('./TemplatePreview.vue');
const AiAgentEdit = () => import('./Edit.vue');
const AiAgentRunLogs = () => import('./RunLogs.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/ai-agents'),
      meta: {
        permissions: ['administrator'],
      },
      component: AiAgentsShell,
      children: [
        {
          path: '',
          name: 'ai_agents',
          component: AiAgentsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'templates',
          name: 'ai_agents_templates',
          component: AiAgentTemplates,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'templates/:slug',
          name: 'ai_agents_template_preview',
          component: AiAgentTemplatePreview,
          meta: {
            permissions: ['administrator'],
            fullWidth: true,
          },
        },
        {
          path: 'new',
          name: 'ai_agents_new',
          component: AiAgentCreate,
          meta: {
            permissions: ['administrator'],
            fullWidth: true,
          },
        },
        {
          path: ':id/edit',
          name: 'ai_agents_edit',
          component: AiAgentEdit,
          meta: {
            permissions: ['administrator'],
            fullWidth: true,
          },
        },
        {
          path: ':id/runs',
          name: 'ai_agents_runs',
          component: AiAgentRunLogs,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
